module.exports = __webpack_public_path__ + "static/media/client-facebook.29631d87.png";